import { AiMatchingRouteGate } from "../../components/AiMatchingRouteGate";
import { DashboardLegacy } from "../legacy/DashboardLegacy";
import { DashboardPreview } from "./DashboardPreview";

export const Dashboard = () => (
  <AiMatchingRouteGate preview={<DashboardPreview />} legacy={<DashboardLegacy />} />
);
